import axios from '@/axios'
const secretFile = 'ADeuASAfdDsadkdakK5IJas3CQ5h0TfrWGbiyHbYHBBIblitndsadJAHSASA7632bnsys7cx3'

const actions = {
  setViewTransactionType({commit}, type) {
    commit('SET_VIEW_TRANSACTION_TYPE', type)
  },
  uploadFileMitra({commit}, payload) {
    let promises = []
    Object.keys(payload).forEach((prop, i) => {
      const promise = new Promise((resolve, reject) => {

        // Set FOrm Data
        const fd = new FormData()
        fd.append('file', payload[prop])

        // Start send
        setTimeout(() => {
          axios.post(process.env.VUE_APP_STORAGE + '/files', fd, {
            headers: {
              secret: secretFile
            }
          })
          .then(response => {
            let result = {}
            Object.assign(result, response.data)
            result.type = prop
            resolve(result)
          })
          .catch(e => reject(e))
        }, 1000 * (i++))
      })

      // Store to array
      promises.push( promise )
    })

    // Start send 
    return new Promise((resolve, reject) => {
      Promise.all(promises)
            .then(files => resolve(files))
            .catch(e => reject(e))
    })
  },
  pmUploadFile({commit}, payload) {
    const uploadKTP = Promise.resolve([])
    // const uploadKTP = new Promise((resolve, reject) => {
    //   const fd = new FormData()
    //   fd.append('file', payload.file_ktp)
    //   axios.post(process.env.VUE_APP_STORAGE + '/files', fd, {
    //     headers: {
    //       secret: secretFile
    //     }
    //   })
    //   .then(response => {
    //     let result = {}
    //     Object.assign(result, response.data)
    //     result.type = 'file_ktp'
    //     resolve(result)
    //   })
    //   .catch(e => reject(e))
    // })

    const uploadEvidence = new Promise((resolve, reject) => {
      const fd = new FormData()
      fd.append('file', payload.file_evidence)
      axios.post(process.env.VUE_APP_STORAGE + '/files', fd, {
        headers: {
          secret: secretFile
        }
      })
      .then(response => {
        let result = {}
        Object.assign(result, response.data)
        result.type = 'file_evidence'
        resolve(result)
      })
      .catch(e => reject(e))
    })

    return new Promise((resolve, reject) => {
      Promise.all([uploadKTP, uploadEvidence])
          .then(values => resolve(values))
          .catch(e => reject(e))
    })
  },
  uploadFile({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_STORAGE + '/files', payload, {
        headers: {
          secret: secretFile
        }
      })
      .then(response => resolve(response.data))
      .catch(e => reject(e))
    })
  },
  getZisSubCategory({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get('/sub/kategori-zis', {
        headers: {
          'Authorization': localStorage.token
        },
        params
      })
        .then(response => resolve(response.data.data))
        .catch(e => reject(e))
    })
  },
  getZisCategory ({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get('/kategori-zis', {
        headers: {
          'Authorization': localStorage.token
        },
        params
      })
        .then(response => resolve(response.data.data))
        .catch(e => reject(e))
    })
  },
  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateUserRole ({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', {userRole: payload.userRole})
  }
}

export default actions
